/* eslint-disable import/prefer-default-export */
// Routes through agenticApiClient so the call carries the BFF-minted
// `Authorization: Bearer <jwt>` the agents Function App requires
// (utils_router gates every route with Depends(get_current_principal)).
// A bare fetch with only `code`/`x-functions-key` 401s with
// AGENTIC_JWT_MISSING in environments that enforce the JWT (e.g. preview).
import { agenticPatch } from '../../utils/agenticApiClient';

export const updateDobStatus = async ({ matchedCaseId, sourceCaseId, status }) => {
  if (!matchedCaseId || !sourceCaseId) {
    throw new Error('Invalid matchedCaseId or sourceCaseId');
  }

  const params = new URLSearchParams({
    source_case_id: sourceCaseId,
    matched_case_id: matchedCaseId,
    status,
  });
  return agenticPatch(`/dob_status_update?${params.toString()}`);
};
